/**
 * @param baseChar string with any length
 * @param index how many times the baseChar will be incremented
 * @returns if 'A' is baseChar and index is 2, it will return 'C',
 *          if '', return '',
 *          if 'Abc' return 'C' as well.
 */
export const getCharacterByIncrementedIndex = (
  baseChar: string,
  index: number,
) => {
  if (baseChar.length === 0) {
    return '';
  }
  const baseCharCode = baseChar.charCodeAt(0);
  return String.fromCharCode(baseCharCode + index);
};
